import styled from "styled-components";

export const HeavyText = styled.span`
  font-weight: 900;
  color: var(--text-primary);
`;

export const LightItalicText = styled.span`
  font-weight: 300;
  font-style: italic;
  color: var(--text-secondary);
`;

export const HeavyItalicText = styled.span`
  font-weight: 800;
  font-style: italic;
  color: var(--text-primary);
`;

export const LightText = styled.span`
  font-weight: 300;
  font-style: normal;
  color: var(--text-secondary);
`;

export const PageTitle = styled.div`
  text-align: center;
  font-size: xx-large;
  padding: 0em;
  font-weight: 400;
  color: var(--text-primary);
  letter-spacing: 0.05em;
`;

export const ArtistName = styled.div`
  text-align: center;
  font-size: xx-large;
  padding: 1em;
  font-weight: 800;
  font-style: italic;
  color: var(--text-primary);
  letter-spacing: 0.02em;
`;

export const AlbumName = styled.div`
  text-align: center;
  font-size: xx-large;
  padding: 1em;
  font-weight: 700;
  font-style: italic;
  color: var(--accent);
`;

export const SmallFont = styled.span`
  font-size: small;
`;

export const LargeFont = styled.span`
  font-size: large;
`;

export const ExtraLargeFont = styled.span`
  font-size: x-large;
  letter-spacing: 0.02em;
`;

export const Image = styled.img`
  max-width: 100%;
  border-radius: 4px;
`;

export const Wrapper = styled.section`
  padding: 0.5em 1em;
`;

export const HeaderWrapper = styled(Wrapper)`
  padding: 1em 1.5em;
  background: linear-gradient(180deg, var(--bg-secondary) 0%, transparent 100%);
  position: sticky;
  top: 0;
  z-index: 100;
  backdrop-filter: blur(10px);
`;

export const Card = styled.div`
  box-sizing: border-box;
  max-width: 450px;
  margin: 0 auto;
  padding: 1.5rem 2rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  background: linear-gradient(145deg, var(--bg-card) 0%, var(--bg-primary) 100%);
  border-radius: 12px;
  border: 1px solid var(--border);
  transition: border-color 0.3s ease, box-shadow 0.3s ease;

  &:hover {
    border-color: var(--text-muted);
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
  }
`;

export const CopyCard = styled(Card)`
  text-align: justify;
  line-height: 1.8;
  color: var(--text-secondary);

  strong, b {
    color: var(--text-primary);
  }
`;

export const TableCard = styled.div`
  box-sizing: border-box;
  max-width: 90%;
  margin: 2rem auto;
  padding: 2rem;
  background: var(--bg-card);
  border-radius: 12px;
  border: 1px solid var(--border);

  h1 {
    color: var(--text-primary);
    font-weight: 300;
    letter-spacing: 0.1em;
    text-transform: uppercase;
    margin-bottom: 1.5rem;
  }
`;

export const Form = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const Input = styled.input`
  padding: 1rem;
  border: 1px solid var(--border);
  border-radius: 8px;
  margin-bottom: 1rem;
  font-size: 0.9rem;
  background: var(--bg-secondary);
  color: var(--text-primary);
  transition: border-color 0.2s ease;

  &:focus {
    outline: none;
    border-color: var(--accent);
  }

  &::placeholder {
    color: var(--text-muted);
  }
`;

export const Button = styled.button`
  background: transparent;
  border: 1px solid var(--accent);
  border-radius: 8px;
  padding: 1rem;
  color: var(--accent);
  font-weight: 600;
  width: 100%;
  margin-bottom: 1rem;
  font-size: 0.9rem;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background: var(--accent);
    color: var(--bg-primary);
  }
`;

export const Logo = styled.img`
  width: 50%;
  margin-bottom: 1rem;
`;

export const HistoryTableWrapper = styled.div`
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
`;

export const HistoryTable = styled.table`
  width: 100%;
  min-width: 600px;
  table-layout: auto;
  border-collapse: separate;
  border-spacing: 0;

  th {
    text-align: left;
    vertical-align: top;
    padding: 0.75rem 1rem;
    color: var(--text-muted);
    font-weight: 400;
    text-transform: uppercase;
    letter-spacing: 0.05em;
    font-size: 0.75rem;
    border-bottom: 1px solid var(--border);
  }

  td {
    text-align: left;
    vertical-align: top;
    padding: 0.75rem 1rem;
    color: var(--text-secondary);
    border-bottom: 1px solid var(--border);
  }

  tr {
    transition: background-color 0.2s ease;
  }

  tbody tr:hover {
    background-color: var(--bg-secondary);
  }

  a {
    color: var(--accent);
    text-decoration: none;

    &:hover {
      color: var(--accent-hover);
      text-decoration: underline;
    }
  }

  @media (max-width: 768px) {
    font-size: 0.85rem;

    th, td {
      padding: 0.5rem;
    }
  }
`;

export const FormError = styled.div`
  background-color: #c0392b;
  margin: 0.5rem 0;
  padding: 0.75rem 1rem;
  border-radius: 8px;
  color: white;
  font-size: 0.9rem;
`;

export const ListItem = styled.li`
  font-weight: 800;
  color: var(--text-primary);
  margin-bottom: 0.5rem;
`;
